<div class="full-height layout-column" [ngClass]="visitPlan.scheduleStatus || visitPlanScheduleStatus.NOT_PLANNED">
  <div class="flex layout-column">

    <div class="layout-row margin-bottom-10">
      <div class="flex layout-row layout-align-start-center gap-5">
        <div class="flex layout-row layout-align-start-center gap-5 name-container">
          <span class="br-body-2 font-weight-600 gray-100 text-ellipsis">{{ visitPlan.name }}</span>
          <app-bringoz-status-tag *ngIf="visitPlan.isArchive"
                                  [status]="'DELETED'">
          </app-bringoz-status-tag>
        </div>
        <!--        <span class="br-body-2 gray-100">{{ visitPlan | bringozDate: 'from' }} - {{ visitPlan | bringozDate:'to' }}</span>-->
        <span class="br-caption-2 font-weight-600 gray-100">
          {{ 'SCHEDULING_PROJECT_STATUS.' + visitPlan.schedulingProjectStatus | translate }}
        </span>
      </div>

      <div *ngIf="!visitPlan.isArchive" class="layout-row layout-align-start-center">
        <bringoz-button type="tertiary"
                        *ngxPermissionsOnly="'schedulingProject.visitPlan.create'"
                        [ngbTooltip]="'Duplicate' | translate"
                        (onClick)="onCreateVisitPlan.emit(visitPlan)">

          <bringoz-icon iconName="copy" class="gray-101"></bringoz-icon>

        </bringoz-button>
        <bringoz-button type="tertiary"
                        *ngxPermissionsOnly="'schedulingProject.visitPlan.update'"
                        [ngbTooltip]="'Edit' | translate"
                        (onClick)="onEditVisitPlan.emit(visitPlan)">

          <bringoz-icon iconName="edit" class="gray-101"></bringoz-icon>

        </bringoz-button>
        <bringoz-button type="tertiary"
                        *ngxPermissionsOnly="'schedulingProject.visitPlan.update'"
                        [ngbTooltip]="'Delete' | translate"
                        (onClick)="onDeleteVisitPlan.emit(visitPlan)">

          <bringoz-icon iconName="trash" class="gray-101"></bringoz-icon>

        </bringoz-button>
      </div>

      <div *ngIf="!!visitPlan.isArchive">
        <bringoz-button type="tertiary"
                        *ngxPermissionsOnly="'schedulingProject.visitPlan.update'"
                        [ngbTooltip]="'Restore' | translate"
                        (onClick)="onRestoreVisitPlan.emit(visitPlan)">
          <bringoz-icon iconName="refresh" class="gray-101"></bringoz-icon>
        </bringoz-button>
      </div>

    </div>


    <div class="layout-row info-row">
      <div class="flex-50 layout-row layout-align-start-center gap-5">
        <span class="br-body-2 gray-100">{{ 'Created By' | translate }}:</span>
        <span class="br-body-2 gray-100">{{ visitPlan.createdBy.name }}</span>
      </div>
      <div class="flex-50 layout-row layout-align-start-center gap-5">
        <span class="br-body-2 gray-100">{{ 'Dates' | translate }}:</span>
        <span class="br-body-2 gray-100">{{ visitPlan | bringozDate: 'from' }} - {{ visitPlan | bringozDate:'to'}}</span>
      </div>
    </div>

    <div class="layout-row info-row">
      <div class="flex-50 layout-row layout-align-start-center gap-5">
        <span class="br-body-2 gray-100">{{ 'Groups' | translate }}:</span>
        <app-bringoz-items-list-display [itemsList]="{list: visitPlan.groupReferences, displayKey: 'name'}"
                                        [maxItems]="1">
        </app-bringoz-items-list-display>
      </div>
      <div class="flex-50 layout-row layout-align-start-center gap-5">
        <span class="br-body-2 gray-100">{{ 'Branches' | translate }}:</span>
        <branches-indicator class="margin-left-5" [branches]="visitPlan.branchReferences"></branches-indicator>
      </div>
    </div>

    <!--    <div class="layout-row info-row">-->
    <!--      <div class="flex-50 layout-row layout-align-start-center gap-5">-->
    <!--        <span class="br-body-2 gray-100">{{ 'Accounts' | translate }}:</span>-->
    <!--        <span class="br-body-2 gray-100">{{ visitPlan.accountIds?.length || '-&#45;&#45;' }}</span>-->
    <!--      </div>-->
    <!--      <div class="flex-50 layout-row layout-align-start-center gap-5">-->
    <!--        <span class="br-body-2 gray-100">{{ 'Agents' | translate }}:</span>-->
    <!--        <span class="br-body-2 gray-100">{{ visitPlan.agentIds?.length || '-&#45;&#45;'  }}</span>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="layout-row info-row">
      <div class="flex-50 layout-row layout-align-start-center gap-5">
        <span class="br-body-2 gray-100">{{ 'Service Time Provider' | translate }}:</span>
        <span class="flex br-body-2 gray-100 text-ellipsis"
              [appBringozTooltip]="'VISIT_SLOT_SERVICE_TIME_PROVIDERS.' + visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotServiceTimeProviderType[0] | translate"
              ngbTooltip>
          {{ 'VISIT_SLOT_SERVICE_TIME_PROVIDERS.' + visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotServiceTimeProviderType[0] | translate }}
        </span>
      </div>
      <div class="flex-50 layout-row layout-align-start-center gap-5">
        <span class="br-body-2 gray-100">{{ 'Units Provider' | translate }}:</span>
        <span class="flex br-body-2 gray-100 text-ellipsis"
              [appBringozTooltip]="'VISIT_SLOT_UNITS_PROVIDERS.' + visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotUnitsProviderType[0] | translate"
              ngbTooltip>
          {{ 'VISIT_SLOT_UNITS_PROVIDERS.' + visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotUnitsProviderType[0] | translate }}
        </span>
      </div>
    </div>

    <div class="layout-row info-row">
      <div class="flex-50 layout-row layout-align-start-center gap-5">
        <span class="br-body-2 gray-100">{{ 'Delivery Time Provider' | translate }}:</span>
        <span class="flex br-body-2 gray-100 text-ellipsis"
              [appBringozTooltip]="'VISIT_SLOT_DELIVERY_TIME_PROVIDERS.' + visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotDeliveryTimeProviderType[0] | translate"
              ngbTooltip>
          {{ 'VISIT_SLOT_DELIVERY_TIME_PROVIDERS.' + visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotDeliveryTimeProviderType[0] | translate }}
        </span>
      </div>
      <div class="flex-50 layout-row layout-align-start-center gap-5">
        <app-bringoz-state-link class="flex text-ellipsis"
                                [permission]="'schedulingProject.visitPlan.get'"
                                [state]="'scheduling-project.visit-plan'"
                                [params]="{id: visitPlan.id}"
                                [text]="visitPlan.scheduleStatus !== visitPlanScheduleStatus.PLANNED ? ('Go to visit plan' | translate) : ('Go to weekly schedule' | translate)">
        </app-bringoz-state-link>
      </div>
    </div>


  </div>
</div>


<!--<div class="full-height layout-column" [ngClass]="visitPlan.scheduleStatus || visitPlanScheduleStatus.NOT_PLANNED">-->
<!--  <div class="layout-column">-->
<!--    <div class="layout-row layout-align-start-center">-->
<!--      <span class="br-body-1 font-weight-600 gray-100">{{ visitPlan.name }}</span>-->
<!--      <span class="flex"></span>-->

<!--      <app-bringoz-state-link class="text-ellipsis"-->
<!--                              [permission]="'schedulingProject.visitPlan.get'"-->
<!--                              [state]="'scheduling-project.visit-plan'"-->
<!--                              [params]="{id: visitPlan.id}"-->
<!--                              [text]="visitPlan.scheduleStatus !== visitPlanScheduleStatus.PLANNED ? ('Go to visit plan' | translate) : ('Go to weekly schedule' | translate)">-->
<!--      </app-bringoz-state-link>-->

<!--      &lt;!&ndash;    <app-bringoz-state-link *ngIf="visitPlan.scheduleStatus !== visitPlanScheduleStatus.PLANNED"&ndash;&gt;-->
<!--      &lt;!&ndash;                            class="text-ellipsis"&ndash;&gt;-->
<!--      &lt;!&ndash;                            [permission]="'schedulingProject.visitPlan.get'"&ndash;&gt;-->
<!--      &lt;!&ndash;                            [state]="'scheduling-project.visit-plan'"&ndash;&gt;-->
<!--      &lt;!&ndash;                            [params]="{id: visitPlan.id}"&ndash;&gt;-->
<!--      &lt;!&ndash;                            [text]="'Go to visit plan' | translate">&ndash;&gt;-->
<!--      &lt;!&ndash;    </app-bringoz-state-link>&ndash;&gt;-->

<!--      <bringoz-button type="tertiary"-->
<!--                      (onClick)="onEditVisitPlan.emit(visitPlan)">-->

<!--        <bringoz-icon iconName="edit" class="gray-101"></bringoz-icon>-->

<!--      </bringoz-button>-->

<!--      <bringoz-button type="tertiary"-->
<!--                      (onClick)="onDeleteVisitPlan.emit(visitPlan)">-->

<!--        <bringoz-icon iconName="trash" class="gray-101"></bringoz-icon>-->

<!--      </bringoz-button>-->
<!--    </div>-->
<!--    <div class="layout-row layout-align-start-center margin-top-5">-->
<!--      <span class="gray-100">{{ visitPlan | bringozDate: 'from' }}-->
<!--        - {{ visitPlan | bringozDate:'to' }}</span>-->
<!--      <span-->
<!--        class="br-caption-2 font-weight-600 gray-100 margin-left-5">-->
<!--        {{ 'SCHEDULING_PROJECT_STATUS.' + visitPlan.schedulingProjectStatus | translate }}</span>-->
<!--&lt;!&ndash;      <app-visit-plan-status *ngIf="visitPlan.status !== visitPlanStatuses.Import" [status]="visitPlan.status"&ndash;&gt;-->
<!--&lt;!&ndash;                             class="margin-left-5"></app-visit-plan-status>&ndash;&gt;-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
